import React from 'react';
import { IWIPColumn, IWIPTask } from '@/types/psi';
import WIPTaskCard from './WIPTaskCard';

interface WIPKanbanColumnProps {
  column: IWIPColumn;
  tasks: IWIPTask[];
  onTaskClick?: (task: IWIPTask) => void;
  language?: 'en' | 'zh';
}

const WIPKanbanColumn: React.FC<WIPKanbanColumnProps> = ({
  column,
  tasks,
  onTaskClick,
  language = 'en',
}) => {
  const title = language === 'zh' ? column.titleZh : column.title;

  return (
    <div className="flex-shrink-0 w-72 bg-gray-50 dark:bg-gray-900 rounded-lg">
      {/* Column Header */}
      <div className="p-3 border-b border-gray-200 dark:border-gray-700">
        <div className="flex items-center justify-between">
          <h3 className="font-medium text-gray-900 dark:text-white">
            {title}
          </h3>
          <span className="px-2 py-0.5 text-xs font-medium text-gray-500 dark:text-gray-400 bg-gray-200 dark:bg-gray-700 rounded-full">
            {tasks.length}
          </span>
        </div>
      </div>

      {/* Tasks Container */}
      <div className="p-2 space-y-2 max-h-[calc(100vh-320px)] overflow-y-auto">
        {tasks.length === 0 ? (
          <div className="py-8 text-center">
            <svg
              className="w-8 h-8 mx-auto text-gray-300 dark:text-gray-600"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.5}
                d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"
              />
            </svg>
            <p className="mt-2 text-sm text-gray-400 dark:text-gray-500">
              No tasks
            </p>
          </div>
        ) : (
          tasks.map((task) => (
            <WIPTaskCard
              key={task.id}
              task={task}
              onClick={onTaskClick}
            />
          ))
        )}
      </div>
    </div>
  );
};

export default WIPKanbanColumn;
